module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/69f93535ecf644573af392c0750dfb66.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tooltip-arrow.png
// module id = cRa8
// module chunks = 1